import ajax from "../../lib/appfuse-react/core/ajax";

const reissueCertificateService = {

    requestToken: async (email) => {
        const response = await ajax.get(`reissueCertificates/sendVerificationCode/${email}`);
        return response.ok;
    },
    verifyEmail: async (email, token) => {
        const response = await ajax.get(`reissueCertificates/confirmVerificationCode/${email}/${token}`);
        return response.ok;
    },

    validate: async (data) => {
        const response = await ajax.post('reissueCertificates/validate', data);
        return response.data;
    },
    complete: async (data) => {
        const response = await ajax.post('reissueCertificates', data);
        return response.data;
    },

}

export default reissueCertificateService;